import { useState } from 'react'
import { Resume, UserDocumentTemplate } from '@rio/types'

import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useGetTemplateCategories } from 'builder/hooks/useGetTemplateCategories'
import { TemplateCategories, TemplateChangeHandler } from 'builder/modules/resumeEditor'

import { TemplatesMobile } from './TemplatesMobile'
import { TemplateCategories as TemplateCategoriesComponent } from './TemplateCategories'
import * as Styled from './styles'

type Props = {
  templates: UserDocumentTemplate[]
  updateTemplate: TemplateChangeHandler
  currentDocument: Resume
  currentTemplate?: UserDocumentTemplate
}

export const Templates = (props: Props) => {
  const { isAboveTablet } = useMediaQueries()
  const { data: templateCategories, isLoading } = useGetTemplateCategories()
  const [selectedCategory, setSelectedCategory] = useState<TemplateCategories>(
    TemplateCategories.all,
  )

  const selectedTemplates =
    templateCategories?.grouped_categories[selectedCategory]?.template_names || []

  const handleSelectCategory = (category: string) => {
    setSelectedCategory(category as TemplateCategories)
  }

  return (
    <Styled.Container>
      <TemplateCategoriesComponent
        isLoading={isLoading}
        selectedCategory={selectedCategory}
        onSelectCategory={handleSelectCategory}
        categories={templateCategories?.grouped_categories}
      />
      {!isAboveTablet ? (
        <TemplatesMobile
          {...props}
          selectedTemplates={selectedTemplates}
          selectedCategory={selectedCategory}
        />
      ) : (
        <Styled.TemplateListContainer>
          <Styled.TemplatesListComponent
            {...props}
            selectedCategory={selectedCategory}
            selectedTemplates={selectedTemplates}
          />
        </Styled.TemplateListContainer>
      )}
    </Styled.Container>
  )
}
